export default __webpack_public_path__ + "static/BaseApplication-1583c220c3cfd9549fb6569311ab1f4a.pdf";